/// <amd-module name="TFS/TeamProfilePanel/TeamProfilePanelConstants" />
export namespace Types {
    export const Backlogs = "Backlogs";
    export const BacklogsType = "Microsoft.TeamFoundation.Work.TeamBacklogs";
    export const Boards = "Boards";
    export const BoardsType = "Microsoft.TeamFoundation.Work.TeamBoardSets";
    export const Dashboards = "Dashboards";
    export const DashboardType = "Microsoft.TeamFoundation.Dashboards.Dashboard";
    export const FavoriteArtifactScopeType = "Project";
    export const Items = "Items";
    export const Members = "Members";
    export const Sprints = "Sprints";
    export const SprintsType = "Microsoft.TeamFoundation.Work.TeamIterations";
    export const Teams = "teams";
    export const Queries = "Queries";
    export const QueriesType = "Microsoft.TeamFoundation.WorkItemTracking.TeamIterations";
}